import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    standalone: false
})
export class SidenavComponent implements OnInit {
  user: any;
  activeRoute: string = '/calendar';

  // Only this samAccountName can see the Health tab.
  private readonly healthTabGmid = 'czc7nm';
  private readonly healthMenuItem = { route: '/health', label: 'Health', icon: 'monitor_heart' };

  private readonly baseNonAdminMenuItems = [
    { route: '/calendar', label: 'Event Calendar', icon: 'event' },
    { route: '/my-requests', label: 'My Requests', icon: 'star' }
  ];

  private readonly baseAdminMenuItems = [
    { route: '/calendar', label: 'Event Calendar', icon: 'event' },
    { route: '/admin-events', label: 'Admin Events', icon: 'admin_panel_settings' },
    { route: '/my-requests', label: 'My Requests', icon: 'star' },
    { route: '/blocked-users', label: 'Blocked Users', icon: 'block' }
  ];

  private readonly baseOwnerMenuItems = [
    { route: '/calendar', label: 'Event Calendar', icon: 'event' },
    { route: '/admin-events', label: 'Admin Events', icon: 'admin_panel_settings' },
    { route: '/my-requests', label: 'My Requests', icon: 'star' },
    { route: '/admin', label: 'Admin Controls', icon: 'check_box' },
    { route: '/blocked-users', label: 'Blocked Users', icon: 'block' }
  ];

  // Computed once per user change (not on every change-detection cycle) to avoid
  // *ngFor tearing down/rebuilding nav DOM on every CD tick.
  nonAdminMenuItems = this.baseNonAdminMenuItems;
  adminMenuItems = this.baseAdminMenuItems;
  ownerMenuItems = this.baseOwnerMenuItems;

  constructor(private userService: UserService, private router: Router) { }

  ngOnInit() {
    this.userService.user$.subscribe((user) => {
      if (user) {
        console.log('Sidenav received user data:', user);
        this.user = user;
        this.updateMenuItems();
      }   
    });

    // Track active route
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.activeRoute = event.url;
    });
  }

  private updateMenuItems(): void {
    const isHealthTabAuthorized = this.user?.gmid === this.healthTabGmid;
    this.nonAdminMenuItems = isHealthTabAuthorized ? [...this.baseNonAdminMenuItems, this.healthMenuItem] : this.baseNonAdminMenuItems;
    this.adminMenuItems = isHealthTabAuthorized ? [...this.baseAdminMenuItems, this.healthMenuItem] : this.baseAdminMenuItems;
    this.ownerMenuItems = isHealthTabAuthorized ? [...this.baseOwnerMenuItems, this.healthMenuItem] : this.baseOwnerMenuItems;
  }

  isActive(route: string): boolean {
    return this.activeRoute === route;
  }

  onImageLoad(event: any): void {
    // console.log('Profile image loaded successfully:', event.target.src);
  }

  onImageError(event: any): void {
    console.error('Profile image failed to load:', event.target.src);
    console.log('Falling back to default icon');
    // Remove the picture property to show the default icon
    if (this.user) {
      this.user.picture = null;
    }
  }

  toggleAdmin(): void {
    if (this.user) {
      this.user.isAdmin = !this.user.isAdmin;
      this.userService.setUserObservable(this.user);
    } else {
      console.warn('User is not defined, cannot toggle admin status.');
    }
  }

  toggleOwner(): void {
    if (this.user) {
      this.user.isOwner = !this.user.isOwner;
      if (this.user.isOwner) {
        this.user.isAdmin = true;
      }
      this.userService.setUserObservable(this.user);
    } else {
      console.warn('User is not defined, cannot toggle owner status.');
    }
  }
  
  handleLogoError(event: Event): void {
    const img = event.target as HTMLImageElement | null;
    if (!img) return;
    console.error('[Logo] failed to load primary source:', img.src);
    // Attempt fallback name if different
    if (!img.dataset['fallbackApplied']) {
      img.dataset['fallbackApplied'] = '1';
      img.src = 'assets/broadcast_logof.png';
    }
  }
}